import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postOrdersURL } from "../utils/api";
import {
    Box,
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Text,
    Select,
    Progress,
    Table,
    Thead,
    Tbody,
    Th,
    Tr,
    Td,
    HStack,
    RadioGroup,
    Radio,
    useDisclosure, 
    useColorModeValue,
} from "@chakra-ui/react";
import useGetCustomers from "../hooks/useGetCustomers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "assets/css/easychek.css";
import { clearDraft } from "../reducers/draft";
import { RepeatIcon, SpinnerIcon, AddIcon } from '@chakra-ui/icons'
import CreateCustomer from "./CreateCustomer";
import SearchCustomer from "views/Custom/SearchCustomer";


function CreateOrder({
    isOpen,
    onClose,
    orderData,
}) {

    if (orderData == null) {
        return (<></>);
    }
    const textColor = useColorModeValue("gray.700", "white");

    const { auth, draftDispatch } = useAuth();
    // let { customers, setGettingCustomers, gettingCustomers, gettingCustomersReqSuccess } = useGetCustomers({ page: 1, limit: 4000 });

    const [ orderCustomer, setOrderCustomer ] = useState(null);
    const [ receiveDate, setReceiveDate ] = useState(new Date());
    const [ warrantyEnd, setWarrantyEnd ] = useState(new Date());
    const [ paymentType, setPaymentType ] = useState('Cash');
    const [ paymentAmount, setPaymentAmount ] = useState('0.0');
    const [ paymentBank, setPaymentBank ] = useState(null);
    const [ paymentRef, setPaymentRef ] = useState(null);
    const [ paymentAccountNumber, setPaymentAccountNumber ] = useState(null);
    const [ paymentAccountName, setPaymentAccountName ] = useState(null);
    const [ paymentChequeNumber, setPaymentChequeNumber ] = useState(null);
    const [ discount, setDiscount ] = useState('0');


    const [ laborTotal, setLaborTotal ] = useState(0);
    const [ partsTotal, setPartsTotal ] = useState(0);
    
    const [ submitting, setSubmitting ] = useState(false);
    const [ successMsg, setSuccessMsg ] = useState(null);
    const [ errors, setErrors ] = useState([]);

    const [ invPaymentAmount, setInvPaymentAmount ] = useState(null);
    const [ invPaymentBank, setInvPaymenBank ] = useState(null);
    const [ invPaymentRef, setInvPaymentRef ] = useState(null);
    const [ invPaymentAccountNumber, setInvPaymentAccountNumber ] = useState(null);
    const [ invPaymentAccountName, setInvPaymentAccountName ] = useState(null);
    const [ invPaymentChequeNumber, setInvPaymentChequeNumber ] = useState(null);
    const [ invDiscount, setInvDiscount ] = useState(null);


    const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();


    const postOrder = (e) => {
        e.preventDefault();

        setSubmitting(true);
        setErrors([]);
        setSuccessMsg(null);

        // console.log(stock, price);
        axios.post(postOrdersURL, {
            customerId: orderCustomer.id,
            carMake: orderData.carMake,
            carType: orderData.carType,
            carYear: orderData.carYear,
            carPlate: orderData.carPlate,
            carOdometer: orderData.carOdometer,
            receiveDate: receiveDate.toISOString(),
            warrantyEnd: warrantyEnd.toISOString(),
            services: orderData.orderServices,
            mechanics: orderData.orderMechanics, 
            payment: {
                type: paymentType,
                amount: paymentAmount,
                bank: paymentType == 'Online' 
                    ? paymentBank : undefined,
                referenceNumber: paymentType == 'Online' 
                    ? paymentRef : undefined,
                accountNumber: paymentType == 'Cheque'
                    ? paymentAccountNumber: undefined,
                accountName: paymentType == 'Cheque'
                    ? paymentAccountName: undefined,
                chequeNumber: paymentType == 'Cheque'
                    ? paymentChequeNumber: undefined,
            },
            discount: discount, 
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200 || result.status === 201) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                setOrderCustomer(null);
                draftDispatch(clearDraft());
                // setInstallment(3);
                setSuccessMsg("Order Added! Please proceed to dashboard to view the order");
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    // const handleSelectCustomer = (e) => {
    //     customers.forEach((c) => {
    //         if (c.id == e.target.value) {
    //             // console.log(c);
    //             setOrderCustomer(c);
    //         }
    //     });
    // }

    useEffect(() => {
        if (orderData && isOpen) {
            let lTotal = 0;
            let pTotal = 0;
            if (orderData.orderServices.length > 0) {
                orderData.orderServices.forEach((os, osIndex) => {
                    // console.log(parseFloat(os.price));
                    lTotal += parseFloat(os.price);
                    // console.log(laborTotal);
                    if (os.addedProducts.length > 0) {
                        os.addedProducts.forEach((p) => {
                            p.addedStocks.forEach((s) => {
                                pTotal += (parseFloat(s.quantity) * parseFloat(s.price));
                            });
                        });
                        // console.log(partsTotal);
                    }
                });
            }
            setLaborTotal(lTotal);
            setPartsTotal(pTotal);
            setErrors([]);
            
            if (isNaN(lTotal + pTotal)) {
                setErrors(["Invalid pricing, Pls check service item's quantity or price"]);
            }
            // console.log(orderData);
        }

    }, [orderData, isOpen]);

    // useEffect(() => {
    //     setGettingCustomers(true);
    // }, []);


    // useEffect(() => {
    //     console.log(orderCustomer);
    // }, [orderCustomer]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Create New Order</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postOrder}>
                    <Flex flexDirection="column" w="100%">
                        
                        {/* Customer */}
                        <Flex flexDirection="row">
                            {/* <Box flex={1}>
                                <FormControl marginBottom="12px">
                                    <FormLabel>Please Select Customer</FormLabel>
                                    {   gettingCustomers
                                        ? <Progress isIndeterminate />
                                        : <Select placeholder="Select Customer"
                                            onChange={handleSelectCustomer}>
                                            {   customers.map((user) => {
                                                    return <option key={`customer-select-${user.id}`} 
                                                        value={user.id}>
                                                            { user.companyName 
                                                                ? `${user.companyName} (${user.email})`
                                                                : `${user.firstName} ${user.lastName} (${user.email})`
                                                            }
                                                    </option>
                                                })
                                            }
                                        </Select>
                                    }
                                </FormControl>
                            </Box> */}

                            { orderCustomer
                                ?  <Text 
                                    fontSize="md"
                                    color={textColor}
                                    fontWeight={600}
                                    flexGrow="1"
                                    display="inline-block"
                                    verticalAlign="middle"
                                    margin="auto 0"
                                    >
                                    { orderCustomer.firstName }  { orderCustomer.lastName }
                                </Text> 
                                :<Box flex={1}>
                                    <SearchCustomer 
                                        onCustomerClicked={setOrderCustomer}
                                    />
                                </Box>
                            }
                           
                                    
                            <HStack>
                                {/* <Button variant="transparent" 
                                    color="blue" 
                                    leftIcon={gettingCustomers ? <SpinnerIcon/> : <RepeatIcon />} 
                                    disabled={gettingCustomers} 
                                    onClick={() => {
                                        setOrderCustomer(null);
                                        setGettingCustomers(true);
                                    }}
                                    title="Reload Customers" 
                                    paddingRight={0}
                                /> */}
                                { orderCustomer 
                                    ? <Button variant="transparent" 
                                        color="blue" 
                                        leftIcon={<RepeatIcon />} 
                                        onClick={() => setOrderCustomer(null)}
                                        title="Deselect Customer" 
                                        paddingRight={0}
                                    />
                                    : null 
                                }

                                { !orderCustomer 
                                    ? <Button variant="transparent" 
                                        color="green" 
                                        leftIcon={<AddIcon />} 
                                        onClick={onOpenCreate}
                                        title="Add New Customer"
                                        marginTop={4}
                                        paddingLeft={2}
                                        paddingRight={2}
                                    />
                                    : null
                                }
                            </HStack>

                        </Flex>

                        {/* Receive Date */}
                        <FormControl marginBottom="12px">
                            <Flex flexDirection="row" w="100%">
                                <FormLabel>Receive Date</FormLabel>
                                <DatePicker 
                                    className="easychek-date-picker"
                                    selected={receiveDate} onChange={(date) => setReceiveDate(date)} />
                            </Flex>
                        </FormControl>


                        {/* WArranty Date */}
                        <FormControl marginBottom="12px">
                            <Flex flexDirection="row" w="100%">
                                <FormLabel>Warranty Date</FormLabel>
                                <DatePicker 
                                    className="easychek-date-picker"
                                    selected={warrantyEnd} onChange={(date) => setWarrantyEnd(date)} />
                            </Flex>
                        </FormControl>

                        <Text fontSize="sm" color="gray.400" fontWeight="bold">
                            PAYMENT METHOD
                        </Text>

                        {/* Payment Type */}
                        <RadioGroup 
                            defaultValue="Cash" mb="12px" 
                            onChange={setPaymentType}
                            // value={paymentType}
                        >
                            <HStack spacing="24px">
                                <Radio value="Cash">Cash</Radio>
                                <Radio value="Online">Online</Radio>
                                <Radio value="AccountsReceivable">Accounts Receivable</Radio>
                                <Radio value="Cheque">Cheque</Radio>
                            </HStack>
                        </RadioGroup>

                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Amount
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="0.0"
                                size="md" 
                                isInvalid={invPaymentAmount === true}
                                isRequired={true}
                                value={paymentAmount} 
                                onChange={e => setPaymentAmount(e.target.value)}
                            />
                        </Box>
                        
                        { paymentType == 'Online'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Bank / E-Wallet
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Bank / E-Wallet Name"
                                    size="md" 
                                    isInvalid={invPaymentBank === true}
                                    isRequired={true}
                                    value={paymentBank} 
                                    onChange={e => setPaymentBank(e.target.value)}
                                />
                            </Box>
                            : null 
                        }
                        

                        { paymentType == 'Online'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Reference / Transaction Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Reference / Transaction Number"
                                    size="md" 
                                    isInvalid={invPaymentRef === true}
                                    isRequired={true}
                                    value={paymentRef} 
                                    onChange={e => setPaymentRef(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { paymentType == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Account Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Account Number"
                                    size="md" 
                                    isInvalid={invPaymentAccountNumber === true}
                                    isRequired={true}
                                    value={paymentAccountNumber} 
                                    onChange={e => setPaymentAccountNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { paymentType == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Account Name
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Account Name"
                                    size="md" 
                                    isInvalid={invPaymentAccountName === true}
                                    isRequired={true}
                                    value={paymentAccountName} 
                                    onChange={e => setPaymentAccountName(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { paymentType == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Cheque Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Cheque Number"
                                    size="md" 
                                    isInvalid={invPaymentChequeNumber === true}
                                    isRequired={true}
                                    value={paymentChequeNumber} 
                                    onChange={e => setPaymentChequeNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }
                

                        <Table width={"100%"} border={"1px solid gray"} variant="unstyled">
                            <Tbody>
                                <Tr>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        borderLeft={"1px solid gray"}
                                        paddingInlineStart={2} 
                                        paddingTop={0}
                                        paddingBottom={0}
                                        colSpan={6}
                                    >NAME: { orderCustomer 
                                        ? orderCustomer.companyName 
                                            ? `${orderCustomer.companyName}` 
                                            : `${orderCustomer.firstName} ${orderCustomer.lastName}` 
                                        : '' 
                                    }</Td>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        borderLeft={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        colSpan={6}
                                    >CONTACT NO:  { orderCustomer 
                                        ? orderCustomer.companyNumber 
                                            ? orderCustomer.companyNumber
                                            : orderCustomer.mobile 
                                        : '' 
                                    }</Td>
                                </Tr>
                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        borderLeft={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        colSpan={12}
                                    >ADDRESS:</Td>
                                </Tr>
                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        borderLeft={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        colSpan={6}
                                    >WORKING DAYS:</Td>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        borderLeft={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        colSpan={6}
                                    >DATE: {new Date().toLocaleDateString()}</Td>
                                </Tr>
                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        colSpan={5}
                                        borderRight={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={1}
                                        paddingBottom={0}
                                    >MAKE: {orderData.carMake ?? ''}</Td>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        colSpan={5}
                                        borderRight={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={1}
                                        paddingBottom={0}
                                    >TYPE: {orderData.carType ?? ''}</Td>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        colSpan={2}
                                        borderRight={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={1}
                                        paddingBottom={0}
                                    >YEAR: {orderData.carYear ?? ''}</Td>
                                </Tr>

                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        colSpan={6}
                                        borderRight={"1px solid gray"}
                                        paddingInlineStart={2}
                                        paddingTop={1}
                                        paddingBottom={0}
                                    >PLATE NO: {orderData.carPlate ?? ''}</Td>
                                    <Td fontSize="xs"
                                        textAlign="start"
                                        colSpan={6}
                                        paddingInlineStart={2}
                                        paddingTop={1}
                                        paddingBottom={0}
                                    >ODOMETER:  {orderData.carOdometer ?? ''}</Td>
                                </Tr>

                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={1}
                                        borderRight={"1px solid gray"}
                                        paddingTop={2}
                                        paddingBottom={1}
                                        width="8%"
                                    >QTY</Td>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={7}
                                        borderRight={"1px solid gray"}
                                        paddingTop={2}
                                        paddingBottom={1}
                                        width="50%"
                                    >NATURE OF WORK</Td>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={1}
                                        borderRight={"1px solid gray"}
                                        paddingTop={2}
                                        paddingBottom={1}
                                    >PARTS</Td>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={3}
                                        borderRight={"1px solid gray"}
                                        paddingTop={2}
                                        paddingBottom={1}
                                    >LABOR</Td>
                                </Tr>

                                { orderData.orderServices.map((os, osIndex) => {
                                    return os.addedProducts.map((p, pIndex) => {
                                        return p.addedStocks.map((s, sIndex) => {
                                            if (parseInt(s.quantity) == 0) {
                                                return null;
                                            }
                                            return <Tr key={`osrow-${osIndex}-${pIndex}-${sIndex}`}>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={1}
                                                    borderRight={"1px solid gray"}
                                                    // borderTop={pIndex == 0 ? "1px solid gray" : ""}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >{s.quantity}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={7}
                                                    borderRight={"1px solid gray"}
                                                    // borderTop={pIndex == 0 ? "1px solid gray" : ""}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >{p.name}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    // borderTop={pIndex == 0 ? "1px solid gray" : ""}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >₱{Number(s.price).toLocaleString()}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    // borderTop={pIndex == 0 ? "1px solid gray" : ""}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                ></Td>
                                            </Tr>
                                        })
                                    })
                                        
                                })
                                }


                                { orderData.orderServices.map((os, osIndex) => {
                                    if (os.title.toString().trim().toLowerCase() == 'non-service' 
                                        && parseInt(os.price) === 0) {
                                        return null;
                                    }
                                    return <Tr key={`osrow-${osIndex}`}>
                                            <Td fontSize="xs"
                                                textAlign="center"
                                                colSpan={1}
                                                borderRight={"1px solid gray"}
                                                borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            ></Td>
                                            <Td fontSize="xs"
                                                textAlign="start"
                                                colSpan={7}
                                                borderRight={"1px solid gray"}
                                                borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            >{os.title}</Td>
                                            <Td fontSize="xs"
                                                textAlign="center"
                                                colSpan={2}
                                                borderRight={"1px solid gray"}
                                                borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            ></Td>
                                            <Td fontSize="xs"
                                                textAlign="center"
                                                colSpan={2}
                                                borderRight={"1px solid gray"}
                                                borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            >₱{Number(os.price).toLocaleString()}</Td>
                                        </Tr>
                                    })
                                        
                                }

                                { orderData.orderMechanics.map((om, omIndex) => {
                                        if (om.firstName.toString().trim().toLowerCase() == 'non' 
                                            && om.lastName.toString().trim().toLowerCase() == 'mechanic' ) {
                                            return null;
                                        }
                                        return <Tr key={`osrow-${omIndex}`}>
                                            <Td fontSize="xs"
                                                textAlign="start"
                                                colSpan={8}
                                                borderRight={"1px solid gray"}
                                                borderTop={omIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            >{om.firstName } {om.lastName}</Td>
                                            <Td fontSize="xs"
                                                textAlign="start"
                                                colSpan={2}
                                                borderRight={"1px solid gray"}
                                                borderTop={omIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            ></Td>
                                            <Td fontSize="xs"
                                                textAlign="center"
                                                colSpan={2}
                                                borderRight={"1px solid gray"}
                                                borderTop={omIndex == 0 ? "1px solid gray" : ""}
                                                paddingTop={0}
                                                paddingBottom={0}
                                            ></Td>
                                        </Tr>
                                    })
                                }

                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={8}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                    >PARTIAL TOTAL</Td>
                                    <Td
                                        // colSpan={3}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        textAlign={"center"}
                                    >
                                        <Text>₱{Number(partsTotal).toLocaleString()}</Text>
                                    </Td>
                                    <Td 
                                        colSpan={3}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        textAlign={"center"}
                                    >
                                        <Text>₱{Number(laborTotal).toLocaleString()}</Text>
                                    </Td>
                                </Tr>

                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={8}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                    >SUBTOTAL</Td>
                                    <Td
                                        colSpan={4}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        textAlign="center"
                                    >
                                        <Text>₱{Number(laborTotal + partsTotal).toLocaleString()}</Text>
                                    </Td>
                                </Tr>

                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        textAlign="center"
                                        colSpan={8}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                    >DISCOUNT</Td>
                                    <Td
                                        colSpan={4}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        textAlign="center"
                                    >
                                        <Text>₱{Number(discount).toLocaleString()}</Text>
                                    </Td>
                                </Tr>

                                <Tr border={"1px"}>
                                    <Td fontSize="xs"
                                        fontWeight="bold"
                                        textAlign="center"
                                        colSpan={8}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                    >GRAND TOTAL</Td>
                                    <Td
                                        colSpan={4}
                                        borderRight={"1px solid gray"}
                                        paddingTop={0}
                                        paddingBottom={0}
                                        textAlign="center"
                                    >
                                        <Text fontWeight={"bold"}>₱{Number((laborTotal + partsTotal) - parseFloat(discount)).toLocaleString()}</Text>
                                    </Td>
                                </Tr>

                            </Tbody>
                            {/* <Tfoot>
                                <Tr>
                                <Th>To convert</Th>
                                <Th>into</Th>
                                <Th isNumeric>multiply by</Th>
                                </Tr>
                            </Tfoot> */}
                        </Table>


                        <Box pr="12px">
                            <FormLabel mt="12px" ms="4px" fontSize="sm" fontWeight="normal">
                                Discount
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="0.0"
                                size="md" 
                                isInvalid={invDiscount === true}
                                isRequired={true}
                                value={discount} 
                                onChange={e => setDiscount(e.target.value)}
                            />
                        </Box>

                    
                        <Spacer />

                        { successMsg ?? <Text color="primary">{successMsg}</Text> }

                        <Flex w="100%" flexDir="column">
                            { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                        </Flex>

                        <Button
                            fontSize="10px"
                            type="submit"
                            bg="teal.300"
                            w="100%"
                            h="45"
                            mb="20px"
                            color="white"
                            mt="12px"
                            _hover={{
                            bg: "teal.200",
                            }}
                            _active={{
                            bg: "teal.400",
                            }}
                            isDisabled={!orderData 
                                || submitting 
                                || !orderCustomer 
                                || isNaN((laborTotal + partsTotal) - parseFloat(discount))
                            }
                        >
                            SUBMIT
                        </Button>

                    </Flex>
                </form>
            </ModalBody>
            </ModalContent>

                   
            <CreateCustomer 
            isOpen={isOpenCreate}
            onClose={onCloseCreate}
            successCallback={() => setGettingCustomers(true)}
            />
        </Modal>
    );

}



export default CreateOrder;
